import { useEffect, useState } from 'react';
import { LuPause, LuPlay } from 'react-icons/lu';
import { API } from '@unboared/react';

import { Button } from '~/components/ui/button';

export function PauseButton({ onToggle }: { onToggle?: (paused: boolean) => void } = {}) {
    const [isPaused, setIsPaused] = useState(false);

    useEffect(() => {
        const unsub = API.onPause(() => {
            setIsPaused(true);
        });
        const unsub2 = API.onResume(() => {
            setIsPaused(false);
        });
        return () => {
            unsub();
            unsub2();
        };
    }, []);

    const pause = () => {
        setIsPaused(true);
        API.pause();
    };

    const resume = () => {
        setIsPaused(false);
        API.resume();
    };

    return (
        <Button
            preset="secondary"
            icon={isPaused ? <LuPlay /> : <LuPause />}
            onClick={() => {
                onToggle?.(!isPaused);
                if (isPaused) resume();
                else pause();
            }}
        />
    );
}
